<template>
  <div v-if="compactDisplay" class="eventArea">
    <span itemprop="address" class="eventArea-compact">{{ areaName }}</span>
  </div>
  <div v-else class="eventArea">
    <icon class="eventArea-icon marginR3" fas="fa-map-marker-alt" />
    <div class="eventArea-name" itemscope="" itemprop="location" itemtype="http://schema.org/Place">
      <span itemprop="address">{{ prefecture.name }}/{{ area.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    area: { type: Object, default: null, required: true },
    prefecture: { type: Object, default: null, required: false },
    onlineEventType: { type: String, default: '', required: false },
    allOptionalPrefecturesSelected: { type: Boolean, default: false, required: false },
    compactDisplay: { type: Boolean, default: false, required: false }
  },
  computed: {
    areaName() {
      if (this.allOptionalPrefecturesSelected || this.onlineEventType === 'online_service_linktext') return 'オンライン'
      if (this.onlineEventType && this.onlineEventType !== 'offline') return `オンライン ${this.prefecture.name}その他`
      return this.area.name
    }
  }
}
</script>

<style lang="scss" scoped>
.eventArea {
  display: inline-flex;
  font-size: 2rem;
  font-weight: bold;
  &-icon {
    flex: 0 0 auto;
    font-size: 1.8rem;
    color: $base-light;
  }
  &-compact {
    color: $white;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-width: 60px;
    display: inline-block;
    vertical-align: middle;
    overflow: hidden;
    background: $gray-55;
    font-size: 1.2rem;
    text-align: center;
    border-radius: 3px;
    padding: 0 0.6rem;
  }
}
</style>
